import type { Slide } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { BaseSceneSwapBridge } from 'js/src/libs/scene-swapping/BaseBridge';
import { isVoiceDrivenSceneGroup } from 'js/src/luminary';

export class CommonToVoiceoverBridge extends BaseSceneSwapBridge {
    override _from = VideoData.CATEGORY_COMMON;
    override _to = VideoData.CATEGORY_VOICEOVER;

    override _isSwapAllowedFor(originalScene: Slide): boolean {
        // you can swap a common scene to an voiceover scene if the common scene is being
        // used as a part of a voicedriven scene group
        return isVoiceDrivenSceneGroup(originalScene.sceneGroup);
    }
}
